var React = require('react');

function LogobgInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.4037 0H0V382H12.4037V0Z","fill":"#EEEEEE","key":0}),React.createElement("path",{"d":"M90.5469 195.945L89.9268 0H284.045L90.5469 195.945Z","fill":"#EEEEEE","key":1}),React.createElement("path",{"d":"M186.056 208.307L95.5088 298.553V381.382H306.372L186.056 208.307ZM160.008 380.145H127.138V318.333H160.008V380.145ZM153.806 288.663V255.903H206.522V288.663H153.806Z","fill":"#EEEEEE","key":2}),React.createElement("path",{"d":"M241.252 151.44L390.096 5.56317V370.874L241.252 151.44Z","fill":"#EEEEEE","key":3})]);
}

LogobgInline.defaultProps = {"width":"391","height":"382","viewBox":"0 0 391 382","fill":"none"};

module.exports = LogobgInline;

LogobgInline.default = LogobgInline;
